export interface ILanguageDto {
    isoCulture: string
    description: string
}

export default class Language {
    isoCode: string
    title: string

    constructor(dto: ILanguageDto) {
        this.isoCode = dto.isoCulture
        this.title = dto.description
    }
}
